import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { IModalComponent } from '@lib/modal';
import { ModalRating } from './modal-rating.model';
import { monitorLogger } from '../../monitor/monitor-logger';
@Component({
  selector: 'app-modal-rating',
  templateUrl: './modal-rating.component.html',
  styleUrls: ['./modal-rating.component.scss'],
})
export class RatingComponent implements IModalComponent<ModalRating>, OnDestroy, AfterViewInit {
  rating: ModalRating = {
    requisition_id: '',
    grade: 0,
    message: '',
  };

  public close$: EventEmitter<any>;
  public submit$: EventEmitter<ModalRating>;

  @Output() submitRating$: EventEmitter<ModalRating> = new EventEmitter();
  @Input() headerTitle: string;

  public isLoading = false;

  constructor() {
    this.close$ = new EventEmitter();
    this.submit$ = new EventEmitter();
  }

  ngAfterViewInit() {
    monitorLogger.screen.trackScreen('avaliar-chamada-video', 'tela_avaliar_chamada_video');
  }

  ngOnDestroy(): void {}

  public close() {
    monitorLogger.screen.trackScreen('modal-rating', 'clicar_botao_cancelar_feedback');
    this.close$.emit();
  }

  public sendRating() {
    monitorLogger.screen.trackScreen('modal-rating', 'clicar_botao_enviar_de_feedback');
    this.submitRating$.emit(this.rating);
    this.isLoading = true;
  }

  public onStarClick() {
    monitorLogger.screen.trackScreen('modal-rating', 'clicar_icone_classificar_estrela_chamada');
  }
}
